module.exports = __webpack_public_path__ + "epdf-app/dashboard/batch-route-2CZse3Qk.html";